import { Injectable } from '@angular/core';

import { FlyoutManager } from '@core/shared/util';
import { ComponentFlyoutRef, ComponentFlyoutService } from '@core/ui';
import { PlattformkatalogeService } from '@mp/content-manager/plattformkataloge/data-access';

import { KatalogeFlyoutComponent } from '../kataloge-flyout/kataloge-flyout.component';
import { KatalogeQuerier } from '../kataloge-flyout/kataloge-querier';

@Injectable({ providedIn: 'root' })
export class PlattformkatalogeFlyoutFacade extends FlyoutManager {
  constructor(
    private readonly katalogService: PlattformkatalogeService,
    private readonly flyoutService: ComponentFlyoutService,
  ) {
    super();
  }

  promptKatalogSelectionFlyout(params: {
    forId?: string;
    excludeIds?: Array<string>;
  }): ComponentFlyoutRef<KatalogeFlyoutComponent> | undefined {
    if (this.flyoutCurrentlyOpened) {
      return undefined;
    }

    const querier = new KatalogeQuerier(this.katalogService, params);
    const payload = { querier, excludeIds: params.excludeIds };

    const flyoutRef = this.flyoutService.open(KatalogeFlyoutComponent, { payload });

    this.markFlyoutAsOpen();
    this.subscribeToAfterClosed(flyoutRef, () => this.markFlyoutAsClosed());

    return flyoutRef;
  }
}
